const tester = /^\w+([+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const isEmail = (email) =>  tester.test(email);
export default isEmail;